import {axios, API, DataFromUrl, SendRequest} from '@/imports-files/pages/admins/dashboard/clients/new';

export class InterviewStage extends SendRequest {

  async getInteviewStageData(jobId) {
    try {
      const result = await axios.get( API.client.jobs.GET_STAGE_INTERVIEW_TYPE_DATA.replace('$job_id', jobId),
        {
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async getUserByNameOrEmail(params) {
    try {
      const result = await axios.get( API.client.jobs.GET_CLIENT_USERS,
        {
          params: params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async addJobStages(params)
  {
    var jobId     =   new DataFromUrl().getJobId();
    try {
      const result = await axios.post(API.client.jobs.ADD_JOB_STAGES.replace('$job_id', jobId),
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }
}